<template>
<div id="relacion_regimen" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" :title="title" class="elevation-1 px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="camposexcel" :name="title + '.xlsx'" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="camposLayout" :exportFields="encabezadoLayout" :name="'Layout ' + title + '.xlsx'" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>

                                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar Registro' : 'Nuevo Registro'" tipo="modal" />
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modal = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-form ref="form" lazy-validation>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-autocomplete :items="tiposPedimento" v-model="model.tipo_pedimento" label="Tipo Pedimento" item-text="tipo" item-value="tipo" :rules="[rules.required]" ></v-autocomplete>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-autocomplete :items="tiposOperacion" v-model="model.tipo_operacion" label="Tipo Operacion" item-text="tipo" item-value="id" :rules="[rules.required]" ></v-autocomplete>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-autocomplete :items="claves" v-model="model.clave_documento" label="Clave de Documento" item-text="clave" item-value="clave" :rules="[rules.required, validaConjuntoUnico]" ></v-autocomplete>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-autocomplete :items="regimenes" v-model="model.regimen" label="Clave Regimen" item-text="clave" item-value="clave" :rules="[rules.required]" ></v-autocomplete>
                                            </v-flex>
                                        </v-layout>

                                    </v-container>
                                </v-card-text>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false" >
                                    <v-icon>cancel</v-icon>Cancelar
                                </v-btn>
                                <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                    <v-icon>done</v-icon>
                                    {{ update ? "Actualizar" : "Guardar" }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="datos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial v-if="id_cliente == 0" direction="left" :open-on-hover="true" >
                                        <v-btn slot="activator" x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";

import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import {
    Event
} from 'vue-tables-2';
import powerTitulo from "@/components/powerTitulo.vue";
export default {
    components: {
        "v-power-titulo": powerTitulo,
        "v-menu-lateral-apendice": menuLateral
    },

    data: () => ({
        fab: false,
        name: "datagrid",
        importData: [],
        tiposPedimento: [{
            "tipo": 1
        }, {
            "tipo": 2
        }],
        tiposOperacion: [{
            "tipo": "1 - Impo",
            "id": 1
        }, {
            "tipo": "2 - Expo",
            "id": 2
        }],
        claves: [],
        regimenes: [],
        show_loading: true,
        loading: false,
        modal: false,
        update: false,
        url_active: location.href,
        id_cliente: 0,
        editable: true,
        datos: {
            items: []
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        tabla: 26,
        title: "RELACIÓN DE REGIMENES",
        columns: ["tipo_pedimento", "tipo_operacion", "clave_documento", "regimen", "actions"],
        options: {
            filterable: ["tipo_pedimento", "tipo_operacion", "clave_documento", "regimen", ],
            sortable: ["tipo_pedimento", "tipo_operacion", "clave_documento", "regimen", ],
            headings: {
                tipo_pedimento: "Tipo Pedimento",
                tipo_operacion: "Tipo Operación",
                clave_documento: "Clave Documento",
                regimen: "Regimen",
                actions: "Operaciones"
            },
        },
        camposexcel: {
            "Tipo Pedimento": "tipo_pedimento",
            "Tipo Operación": "tipo_operacion",
            "Clave Documento": "clave_documento",
            Regimen: "regimen"
        },
        encabezadoLayout: {
            tipo_pedimento: "tipo_pedimento",
            tipo_operacion: "tipo_operacion",
            clave_documento: "clave_documento",
            regimen: "regimen"
        },
        camposLayout: [{
            tipo_pedimento: "[Tipo de Pedimento (1 o 2)]",
            tipo_operacion: "[Tipo de Operación (1 o 2)]",
            clave_documento: "[Clave del Documento (A1,A2, etc.)]",
            regimen: "[Clave del Regimen (IMD, EXD, etc)]"
        }],
        model: {
            id: 0,
            tipo_pedimento: "",
            tipo_operacion: "",
            clave_documento: "",
            regimen: "",
        },
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apendices",
                disabled: true,
                to: ""
            }
        ],

        camposObligatorios: {
            tipo_pedimento: "tipo_pedimento",
            tipo_operacion: "tipo_operacion",
            clave_documento: "clave_documento",
            regimen: "regimen",
        },

    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.datos.items;
            }

        },
    },
    methods: {

        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.update = false;
            } else {
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
        },

        validaConjuntoUnico: function () {
            var result = true;
            if (this.model.tipo_pedimento != "" && this.model.tipo_operacion != "" && this.model.clave_documento != "") {
                var thisObj = this;
                var search = thisObj.datos.items.filter(function (e) {
                    return e.tipo_pedimento == thisObj.model.tipo_pedimento &&
                        e.tipo_operacion == thisObj.model.tipo_operacion &&
                        e.clave_documento == thisObj.model.clave_documento &&
                        e.id != thisObj.model.id;
                });
                if (search.length > 0)
                    result = "La combinación de tipo de pedimento, operación y clave documento ya existe."
            }
            return result;
        },

        verificaClaveDocumento: function (clave) {
            //var thisObj = this;
            var search = this.claves.filter(function (e) {
                return e.clave == clave.toString().toUpperCase();
            });
            if (search.length > 0)
                return true;
            else
                return false;
        },

        verificaRegimen: function (clave) {
            //var thisObj = this;
            var search = this.regimenes.filter(function (e) {
                return e.clave == clave.toString().toUpperCase();
            });
            if (search.length > 0)
                return true;
            else
                return false;
        },

        verificaTipo: function (tipo) {
            //var thisObj = this;
            var search = this.tiposPedimento.filter(function (e) {
                return e.tipo == parseInt(tipo.toString().trim());
            });
            if (search.length > 0)
                return true;
            else
                return false;
        },

        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + this.camposObligatorios[key] + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },

        guardar() {
            var datos = this.model;
            datos["tabla"] = this.tabla;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);
                    })
                    .then(() => {
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargar: function () {
            var datos = {
                tabla: this.tabla
            };
            axios.post(this.URL + "lista/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos.items = res.data;
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            let tabla = this.tabla;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + id_registro + "/", {
                    params: {
                        tabla: tabla
                    }
                })
                .then(response => {
                    this.model = response.data;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            let tabla = this.tabla;
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.URL + id_registro + "/", {
                            params: {
                                tabla: tabla
                            }
                        })
                        .then(response => {
                            this.cargar();
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = '';
            try {

                for (var k in results) {
                    renglonesLeidos++;
                    var obligatorios = thisObject.verificaObligatorios(results[k]);
                    if (obligatorios !== true) {
                        errores++;
                        if (erroresText.indexOf(obligatorios) == -1)
                            erroresText += obligatorios;
                    } else {

                        if (results[k]["clave_documento"] != undefined && results[k]["clave_documento"].toString().trim().length != 2) {
                            errores++;
                            erroresText += "- La clave de documento \"" + results[k]["clave_documento"] + "\" debe tener 2 caracteres.<br>";
                        } else if (results[k]["clave_documento"] != undefined && thisObject.verificaClaveDocumento(results[k]["clave_documento"]) == false) {
                            errores++;
                            erroresText += "- La clave de documento \"" + results[k]["clave_documento"] + "\" no existe en el apéndice de Claves de Pedimento.<br>";
                        } else
                            results[k]["clave_documento"] = results[k]["clave_documento"].toString().toUpperCase();

                        if (results[k]["regimen"] != undefined && results[k]["regimen"].toString().trim().length != 3) {
                            errores++;
                            erroresText += "- La clave de regimen \"" + results[k]["regimen"] + "\" debe tener 3 caracteres.<br>";
                        } else if (results[k]["regimen"] != undefined && thisObject.verificaRegimen(results[k]["regimen"]) == false) {
                            errores++;
                            erroresText += "- La clave de regimen \"" + results[k]["regimen"] + "\" no existe en el apéndice de Regimenes.<br>";
                        } else
                            results[k]["regimen"] = results[k]["regimen"].toString().toUpperCase();

                        if (results[k]["tipo_pedimento"] != undefined && results[k]["tipo_pedimento"].toString().trim().length != 1) {
                            errores++;
                            erroresText += "- El tipo pedimento \"" + results[k]["tipo_pedimento"] + "\" solo puede ser el digito 1 o 2.<br>";
                        } else if (results[k]["tipo_pedimento"] != undefined && thisObject.verificaTipo(results[k]["tipo_pedimento"]) == false) {
                            errores++;
                            erroresText += "- El tipo pedimento \"" + results[k]["tipo_pedimento"] + "\" solo puede ser el digito 1 o 2.<br>";
                        }

                        if (results[k]["tipo_operacion"] != undefined && results[k]["tipo_operacion"].toString().trim().length != 1) {
                            errores++;
                            erroresText += "- El tipo operación \"" + results[k]["tipo_operacion"] + "\" solo puede ser el digito 1 o 2.<br>";
                        } else if (results[k]["tipo_operacion"] != undefined && thisObject.verificaTipo(results[k]["tipo_operacion"]) == false) {
                            errores++;
                            erroresText += "- El tipo operación \"" + results[k]["tipo_operacion"] + "\" solo puede ser el digito 1 o 2.<br>";
                        }
                    }

                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText += "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise      
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            /*for (var k in results){            
                  results[k]['user_updated'] = this.$local_storage.get('username'); 
                  //console.log("Key is " + k + ", value is" + results[k]);  
              }*/
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {

                    let tabla = this.tabla;
                    this.importData = results;
                    axios
                        .post(this.URL + "importar_apendice/?tabla=" + tabla, this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                for (var i = 0; i < err.response.data.length; i++) {
                                    Object.keys(err.response.data[i]).forEach(function (key) {
                                        errores +=
                                            "Fila " +
                                            (i + 2) +
                                            " => " +
                                            key +
                                            ": " +
                                            err.response.data[i][key];
                                        errores += "<br>";
                                    });
                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },

        cargarClaves: function () {
            axios
                .post(this.$hostname + "apendices/lista/", {
                    tabla: 13
                })
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.claves = res.data;
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al apéndice de claves de pedimento",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el apéndice de claves de pedimento.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargarRegimenes();
                });
        },
        cargarRegimenes: function () {
            axios
                .post(this.$hostname + "apendices/lista/", {
                    tabla: 7
                })
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.regimenes = res.data;
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al apéndice de Regimenes",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el apéndice de Regimenes.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargar();
                });
        },

    }, //methods

    created: function () {
        this.tabla = 26;
        this.URL = this.$hostname + "apendices/";        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.id_cliente = this.$local_storage.get("id_cliente");
        if (this.id_cliente > 0 && this.tabla != 2) {
            //Los clientes no pueden modificar los apendices, excepto el de 2-Unidades de Medida y (por definir PILOS)
            this.editable = false;
            delete this.options.headings["actions"];
            var key = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "actions") key = k;
            }
            if (key > 0) delete this.columns[key];
        }
        this.cargarClaves();
    }
};
</script>

<style>
.VueTables__limit {
    display: none;
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 32px !important;
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 32px !important;
}
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>